import React from 'react'
import {Image} from 'cloudinary-react'
import SlideWrapper from './slideWrappers/SlideWrapper'
import StaticLetterBlock from './StaticLetterBlock'
import FallbackStaticQuestionSlide from './FallbackStaticQuestionSlide'
import {getTemplateDefinition} from '../../utils/slides/getTemplateDefinition'
import {isSurvey} from '../../utils/isSurvey'

class QuestionSlide extends React.Component{
 
	render(){
		const {isLiveView,showResponseCounts,expectedResponses,colorScheme,alwaysShowLetterblock,question,displayWidth,isReviewScreen, reportView,showCorrect,showGraph,processedResponses, isScanScreen, isAskScreen, totalResponses} = this.props
		let slideTemplate='standard'
		let template
		if(question){
			const isSurveyQuestion=isSurvey(question)
			slideTemplate=question.template || 'standard'
			template=getTemplateDefinition(slideTemplate,question.image,question.body)	

			if(question.xLayout){
				const bodyFontSize=question.xLayout.bodyFS
				const choiceFontSize=question.xLayout.choiceFS
				if(bodyFontSize && choiceFontSize ){
					let bodyCalcCSS= {fontSize: `${bodyFontSize}px`}
					const choicesCalcCSS = {fontSize: `${choiceFontSize}px`}
					const letterArray=['A','B','C','D']
				
					return(
						<SlideWrapper displayWidth={displayWidth} isStatic={true} template={template} reportView={reportView} >	
							<div className='slide-body' style={bodyCalcCSS} >
								{question.body}		
							</div>																		
					

							<div className='slide-imageContainer'> 
								{question.image &&
								<Image							
									cloudName={process.env.REACT_APP_CLOUDINARY_CLOUDNAME}
									publicId={question.image}                                                 
									role='presentation'
									responsive
									dpr='auto'							
			    					width= '900' 
			    					height='900'
			    					crop= 'limit'   
								/>
				
								}
							</div>

							<div style={choicesCalcCSS}>
								<div className="slide-choices">
									{question.choices.map(function (choice,key) {
										let graphPercentageWidth	
										let responseCount=0

										if(processedResponses){
											let graphScaling=totalResponses
											if(isLiveView){
												graphScaling=expectedResponses
											}
											graphPercentageWidth = processedResponses[`responsesAnswer${letterArray[key]}`].length / graphScaling * 100
											responseCount = processedResponses[`responsesAnswer${letterArray[key]}`].length	
										}
										let displayGraph=false
										if(showGraph){
											displayGraph = true
										}
										else if(reportView){
											displayGraph = true									
										}

										
									

	    					return(
	    						<div className={`slide-choice choice--${key}` + (choice.correct ? ' is--correct' : ' isNot--correct') + (colorScheme ? ` is--${colorScheme} `: '') + (isSurveyQuestion ? ' is--survey' : ' isNot--survey') + (isReviewScreen ? ' is--review' : ' ') + (isAskScreen ? ' is--ask' : ' isNot--ask ') + (showCorrect ? ' is--showCorrect' : ' isNot--showCorrect') + (isScanScreen ? ' is--scan': ' isNot--scan') + (showResponseCounts ? ' is--showResponseCounts ': ' isNot--showResponseCounts ')} key={key}>
	    							<StaticLetterBlock 
	    								index={key}	    									    								
	    								isReviewScreen={isReviewScreen}
	    								reportView={reportView}
	    								showCorrect={showCorrect}
	    								isCorrect={choice.correct}
	    								alwaysShowLetterblock={alwaysShowLetterblock}
	    								isSurvey={isSurveyQuestion}
	    							/>	    						
		    						<div className="slide-choice-textContainer">					 				
							 				<div ref='test' className='slide-choice-text'>
							 					{choice.body}
							 				</div>
							 			</div>
							 			{displayGraph &&
							 				<div className='slide-choice-graph'>			 				
							 					<div style={{width: `${graphPercentageWidth}%` }} className='slide-choice-graph-bar' />
							 				</div>
						 				}
						 				{displayGraph && showResponseCounts &&
							 				<div className={'slide-choice-responseCount ' + (responseCount === 0 ? 'slide-choice-responseCount--isZero' : '')}>
							 					{responseCount}
							 				</div>
							 			}
					 				
											</div>)})}
								</div>
							</div>
						</SlideWrapper>	)}else 
					return (
						<FallbackStaticQuestionSlide
							{...this.props}
							template={template}
						/>)
			}
			else{ return(
				 <FallbackStaticQuestionSlide
					{...this.props}
					template={template}
				/>)}
		}else return null}
}


QuestionSlide.defaultProps = {
	displayWidth: 1280,
	showCorrect:false

}




export default QuestionSlide




// WEBPACK FOOTER //
// ./src/components/slides/StaticQuestionSlide.js